import { getConditionalObject } from 'utils/data';

import { customTitleStyles } from '../../MainContent.styles';

export const getAdditionalMortgageTitleStyles = ({ isDeleted, isLienPriorityChanged }) => ({
  ...customTitleStyles,
  color: ({ palette }) => palette.text.dark,
  padding: '10px',
  borderRadius: '4px 4px 0 0',

  '&:after': {
    display: 'none',
  },

  ...getConditionalObject(isDeleted, {
    '& .title': {
      textDecoration: 'line-through',
      textDecorationColor: ({ palette }) => palette.text.highlight,
    },
  }),

  ...getConditionalObject(isLienPriorityChanged, {
    '& .lien-position': {
      color: ({ palette }) => palette.text.highlight,
    },
  }),
});

export const additionalMortgageTitleWrapperStyles = {
  margin: 0,
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderBottom: 'none',
  borderRadius: '4px 4px 0 0',
};

export const additionalMortgageBodyWrapperStyles = {
  padding: '24px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '0 0 4px 4px',
};
